<template>
  <div class="table">
    <div v-if="showSupplierInfo">
      <el-button type="primary" @click="showList">Back To List</el-button>
      <proposal-pane style="margin-top: 10px" :round="roundData" :ssr="ssr"></proposal-pane>
    </div>
    <div v-if="!showSupplierInfo">
      <div v-for="round in rounds">
        <div>Proposal {{round.roundNumber | romanNum}}</div>
        <el-table :data="round.ssrRoundSuppliers" ref="supplierList" border highlight-current-row style="margin-top:15px;">
          <!--供应商编号/邀请码-->
          <el-table-column prop="supplierCode" :label="$t('ssrManage.invitationCode')" width="128"></el-table-column>
          <!--供应商名称-->
          <el-table-column prop="supplierName" :label="$t('ssrManage.supplierName')" min-width="200"></el-table-column>
          <!--Proposal文档下载-->
          <el-table-column prop="proposal" :label="$t('ssrManage.proposalDoc')" width="100" align="center">
            <template slot-scope="scope">
              <file-list :files="scope.row.proposalDocs"></file-list>
            </template>
          </el-table-column>
          <!--提交日期-->
          <el-table-column prop="submitDate" :label="$t('ssrManage.submitDate')" width="150" align="center">
            <template slot-scope="scope">
              {{scope.row.submitDate|dateFormatFilter('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <!--Proposal概述-->
          <!--                    <el-table-column prop="proposalRemark" :label="$t('ssrManage.summarize')" width="200"></el-table-column>-->
          <!--附件下载-->
          <el-table-column :label="$t('ssrManage.downloadAttac')" width="200">
            <template slot-scope="scope">
              <file-list :can-edit="false" :files="scope.row.otherFormat"></file-list>
            </template>
          </el-table-column>
          <!--详情-->
          <el-table-column :label="'Detail'" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="showDetail(round,scope.row)">Get Details</el-link>
            </template>
          </el-table-column>
          <template slot="append">
            <el-row>
              <el-col span="2" style="line-height: 32px;text-align: right;padding-right: 1em;">
                <span>Remark</span>
              </el-col>
              <el-col span="22">
                <el-input v-model="round.remarks"></el-input>
              </el-col>
            </el-row>
          </template>
        </el-table>

      </div>
      <el-row style="margin-top: 2em;">
        <el-col offset="11" span="2">
          <el-button type="primary" @click="saveRoundMark">Save</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import FileList from "@/components/common/fileList";
import ProposalPane from "@/components/page/ssr-manage/proposal-pane";

export default {
  name: 'ssr-detail-ss',
  extends: commonMethods,
  components: { ProposalPane, FileList },
  props: {
    rounds: Array,
    ssr: Object
  },
  data() {
    return {
      roundData: [],
      ssrData: {},
      showSupplierInfo: false,
      labelPosition: 'right',
      supplierList: [{ ssrNo: 'aaa' }],
    }
  },
  watch: {
    rounds(val) {
      this.roundData = this.rounds;
    },
    ssr(val) {
      this.ssrData = this.ssr;
    },
  },
  created() {
  },
  methods: {
    showDetail(round, roundSupplier) {
      this.roundData = JSON.parse(JSON.stringify(round));
      this.roundData.ssrRoundSuppliers = [roundSupplier];
      this.roundData.ssrRoundSupplierCapacities = this.roundData.ssrRoundSupplierCapacities.filter(item => item.tmSupplierId == roundSupplier.tmSupplierId);
      this.roundData.ssrRoundSupplierCosts = this.roundData.ssrRoundSupplierCosts.filter(item => item.tmSupplierId == roundSupplier.tmSupplierId);
      this.roundData.ssrRoundSupplierLogistics = this.roundData.ssrRoundSupplierLogistics.filter(item => item.tmSupplierId == roundSupplier.tmSupplierId);
      this.roundData.ssrRoundSupplierPqcps = this.roundData.ssrRoundSupplierPqcps.filter(item => item.tmSupplierId == roundSupplier.tmSupplierId);
      this.roundData.ssrRoundSupplierPcns = this.roundData.ssrRoundSupplierPcns.filter(item => item.tmSupplierId == roundSupplier.tmSupplierId);
      this.showSupplierInfo = true;
    },
    showList() {
      this.showSupplierInfo = false;
    },
    saveRoundMark() {
      let that = this;
      let ssr = {
        ttSsrId: this.ssrData.ttSsrId,
        ssrRounds: this.ssrData.ssrRounds.map(round => {
          return {
            ttSsrRoundId: round.ttSsrRoundId,
            remarks: round.remarks,
          }
        })
      }
      apiService.saveRoundMark(ssr).then(res => {
        if (res.code == 200) {
          Message.success('Operate Success');
        }
      });
    }
  }
}
</script>
<style scoped>
</style>
